import {useSelector} from "react-redux";
import { getProfitMarginItemTypes} from "../../api/codelist/codeListsSlice";
import {get} from "lodash";
import {Autocomplete, TextField} from "@mui/material";
import {Controller} from "react-hook-form";
import React from "react";

const ProfitMarginItemTypeSelect = ({
                             name,
                             label = "Profit Margin Type code",
                             control,
                             errors,
                             readOnly = false,
                             helperText,
                             onChange
                         }) => {
    const itemTypesOptions = useSelector(getProfitMarginItemTypes);
    const getItemTypesByCode = (code) => {
        return itemTypesOptions.find(itemTypes => itemTypes.code === code);
    };

    const errorMessage = get(errors, name, {})?.message;
    const combinedHelperText = [helperText, errorMessage]
        .filter(Boolean)
        .join(" * ");

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const selectedItemType =
                    getItemTypesByCode(field.value) ??
                    null;
                return (
                    <Autocomplete
                        options={itemTypesOptions}
                        getOptionLabel={(option) => option.code}
                        isOptionEqualToValue={(option, value) =>
                            option.code === value?.code
                        }
                        filterOptions={(options, { inputValue }) => {
                            const q = inputValue.trim().toLowerCase();
                            if (!q) return options;
                            return options.filter(
                                (o) =>
                                    o.code?.toLowerCase().includes(q) ||
                                    o.description?.toLowerCase().includes(q),
                            );
                        }}
                        value={selectedItemType}
                        onChange={(_, selected) => {
                            const newCode =
                                selected?.code || null;
                            field.onChange(newCode);
                            onChange?.(newCode);
                        }}
                        disableClearable={readOnly}
                        readOnly={readOnly}
                        renderOption={(props, option) => (
                            <li {...props} key={option.code}>
                                {option.code} - {option.description}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                sx={{ minWidth: "150px" }}
                                error={!!errorMessage}
                                helperText={combinedHelperText || ""}
                            />
                        )}
                    />
                );
            }}
        />
    );
};

export default ProfitMarginItemTypeSelect;